import { useState, useEffect } from "react";

const EditTask = ({ task, taskList, setTaskList }) => {
    const [editModul, seteditModul] = useState(false)
    const [taskName, setTaskName] = useState("");
    const [taskDiscription, setTaskDiscription] = useState("");

    useEffect(() => {
        setTaskName(task.taskName);
        setTaskDiscription(task.taskDiscription)
    }, [task])

    const handleInput = e => {
        const { name, value } = e.target;
        if (name === "taskName") { setTaskName(value) };
        if (name === "taskDiscription") { setTaskDiscription(value) };
    }
    const handleupdate = (e) => {
        e.preventDefault();
        let taskIndex = taskList.indexOf(task);
        taskList.splice(taskIndex, 1, {
            taskName: taskName,
            taskDiscription: taskDiscription
        });
        localStorage.setItem("taskList", JSON.stringify(taskList));
        window.location.reload()
        // setTaskList([...taskList, { taskName, taskDiscription }]);
        setTaskName("");
        setTaskDiscription("");
        seteditModul(false);
    }


    return (
        <div>
            <button className=" p-2  bg-info" onClick={() => { seteditModul(true) }}>Edit</button>
            {editModul ? (
                <div className="Addtask position-fixed   h-100  w-50  p-4   bg-dark ">
                    <div className="heading text-white  border-bottom "> <h2>Update the Task</h2>
                        <button className="CloseButton p-2 " onClick={() => { seteditModul(false) }}>X</button></div >
                    <label className=" text-white  text-start  fs-2 " htmlFor="task-name">Task Name :</label>
                    <input className=" fs-3 " placeholder="Task Name" name="taskName" required value={taskName} onChange={handleInput} />
                    <label className=" text-white text-start   fs-2 " htmlFor="task-discription">Task Discription :</label>
                    <textarea className="  fs-3 " placeholder="Task Discription" name="taskDiscription " required value={taskDiscription} onChange={handleInput} />
                    <button className="AddButton" onClick={handleupdate}>Update</button>
                </div>
            ) : null}

        </div>)
}
export default EditTask;